module.exports = __webpack_public_path__ + "images/shimo/mindmap-grid-f89a44633f46f571fd98e7084ac286d8.png";